import types from '../../../mutation-types';

export const setPageFilter = ({ dispatch, filter, page, markEndReached }) => {
  dispatch('conversationPage/setCurrentPage', { filter, page }, { root: true });
  if (markEndReached) {
    dispatch('conversationPage/setEndReached', { filter }, { root: true });
  }
};

export const setContacts = (commit, chatList) => {
  commit(
    `contacts/${types.SET_CONTACTS}`,
    chatList.map(chat => chat.meta.sender)
  );
};

export const isOnMentionsView = ({ route: { name: routeName } }) => {
  const MENTION_ROUTES = [
    'conversation_mentions',
    'conversation_through_mentions',
  ];
  return MENTION_ROUTES.includes(routeName);
};

export const isOnUnattendedView = ({ route: { name: routeName } }) => {
  const UNATTENDED_ROUTES = [
    'conversation_unattended',
    'conversation_through_unattended',
  ];
  return UNATTENDED_ROUTES.includes(routeName);
};

export const isOnParticipatingView = ({ route: { name: routeName } }) => {
  const PARTICIPATING_ROUTES = [
    'conversation_participating',
    'conversation_through_participating',
  ];
  return PARTICIPATING_ROUTES.includes(routeName);
};

export const isOnFoldersView = ({ route: { name: routeName } }) => {
  const FOLDER_ROUTES = [
    'folder_conversations',
    'conversations_through_folders',
  ];
  return FOLDER_ROUTES.includes(routeName);
};

export const buildConversationList = (
  context,
  requestPayload,
  responseData,
  filterType
) => {
  const { payload: conversationList, meta: metaData } = responseData;
  // 定制: SET_ALL_CONVERSATION 是 upsert(只增不减), 切换视图(换 tab/status/inbox/labels/team)
  // 时旧会话残留 → 子集视图(如 with_messages)会显示上一个 tab 的全部会话。用"过滤签名"判断:
  // 签名变(切换视图)= replace(先清空 allConversations 再 set, 同 tick 原子化 → 不闪烁, 不动 selectedChatId);
  // 签名同只有 page 变(翻页)= append(保留分页累积)。
  const filterSignature = JSON.stringify({
    assigneeType: requestPayload.assigneeType,
    withMessages: requestPayload.withMessages,
    status: requestPayload.status,
    inboxId: requestPayload.inboxId,
    labels: requestPayload.labels,
    teamId: requestPayload.teamId,
    conversationType: requestPayload.conversationType,
    contactInfo: requestPayload.contactInfo,
    // 定制(2026-09-03): 访客名称搜索也必须触发 replace——否则搜索结果被 upsert 追加到
    // 列表末尾, 顶部仍显示旧列表, 表现为"计数变了但列表内容不对"
    visitorName: requestPayload.visitorName,
  });
  const isFreshView =
    context.state.currentChatListFilter !== filterSignature;
  context.commit(types.SET_CHAT_LIST_FILTER_SIGNATURE, filterSignature);
  context.commit(types.SET_ALL_CONVERSATION, {
    conversations: conversationList,
    replace: isFreshView,
  });
  context.dispatch('conversationStats/set', metaData);
  context.dispatch(
    'conversationLabels/setBulkConversationLabels',
    conversationList
  );
  context.commit(types.CLEAR_LIST_LOADING_STATUS);
  setContacts(context.commit, conversationList);
  setPageFilter({
    dispatch: context.dispatch,
    filter: filterType,
    page: requestPayload.page,
    markEndReached: !conversationList.length,
  });
};
